import React, { useContext } from "react";
import { ButtonRenderProps, ContentSection } from "sprint-common-web";

import { SystemPlatformDetailsContext } from "../context/SystemPlatformDetailsContext";
import { EditShreqIdsButton } from "./edit/EditShreqIdsButton";

export const ShreqIdsSection = (): JSX.Element => {
    const { systemPlatformDetailsItem, isLoading } = useContext(SystemPlatformDetailsContext);

    const { shreqIds } = systemPlatformDetailsItem;

    const editShreqIdsButton: ButtonRenderProps = {
        render: EditShreqIdsButton
    };

    return (
        <ContentSection header="Shreq Ids" buttons={[editShreqIdsButton]} isLoading={isLoading}>
            {shreqIds?.join(", ")}
        </ContentSection>
    );
};
